import React from 'react';
import { Flex, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { FormikProps } from 'formik';

import { RecommendationsForm } from './RecommendationsForm';
import { GenericModal } from '../../../../../shared/ui/GenericModal';
import { RecommendationsProps } from '../service/recommendations.interface';

const { Text } = Typography;

interface Props {
    isLoading: boolean;
    onSubmit: () => void;
    formik: FormikProps<RecommendationsProps>;
}
export const RecommendationsModal = ({
    isLoading,
    formik,
    onSubmit,
}: Props) => {
    const navigate = useNavigate();

    return (
        <GenericModal
            okButtonProps={{
                disabled: isLoading || !formik.isValid || !formik.dirty,
                loading: isLoading,
            }}
            onConfirm={onSubmit}
            okText={'Сохранить'}
            onCancel={() => navigate(-1)}
            title={'Настроить рекомендации'}
            open
        >
            <Flex
                vertical
                gap={24}
                style={{
                    marginTop: 8,
                }}
            >
                <Text>
                    Составляем подборку по выбранному периоду сообщений в
                    сообществах. Информацию анализирует ИИ. Итоговую
                    рекомендацию вы можете найти в разделе &ldquo;История&rdquo;
                </Text>

                <RecommendationsForm formik={formik} />
            </Flex>
        </GenericModal>
    );
};
